module.exports = __webpack_public_path__ + "9779d9a1/img/send-icon.3cfb6275.svg";